import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-316" data-mp="3f2dr93ass1z1">
      {eyebrow && <p className={`text-sm font-extrabold uppercase tracking-wider ${dark ? 'text-mint-400' : 'text-brand-600'}`} data-id="element-317" data-mp="3jzndka2w3xin">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 text-balance text-[1.75rem] font-extrabold leading-tight sm:text-4xl md:text-[2.75rem] ${dark ? 'text-white' : 'text-brand-950'}`} data-id="element-318" data-mp="bmgdylhcadwh">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-balance text-lg ${dark ? 'text-brand-100' : 'text-brand-900/75'}`} data-id="element-319" data-mp="6svdmms9x7u4">{subtitle}</p>}
    </div>;
}